import { useCallback } from 'react';

import { ModalProps } from '@elements/modal';
import { i18n } from '@i18n';
import { openModalSelector, useModalStore } from '@store';

export const useChooseRegion = () => {
  const openModal = useModalStore(openModalSelector);

  const openRegionModal = useCallback(
    (props?: ModalProps) => {
      openModal('RegionGridModal', {
        titleProps: {
          variant: 'h3-28/freely',
          children: i18n.t('global.countryOfResidency.modal.title'),
        },
        ...props,
      });
    },
    [openModal],
  );

  return { openRegionModal };
};
